import React, {Component} from 'react'
import Helmet from 'react-helmet'
import Elm from 'react-elm-components'
import ElmMain from '../../elm/src/ContextualComment.elm'
import i18n from '../i18n'
import {connect} from 'react-redux'
import {errorStatus} from '../core/redux/status'

class ContextualComment extends Component {
    setupPorts = (ports) => {
        const {dispatch} = this.props
        ports.sendErrorToRedux.subscribe(e => {
            dispatch(errorStatus(e))
        })
    }

    render() {
        const flags = this.props.company.company._links.find(x => x.rel === 'contextualcommentref')

        const component = <div>
            <Helmet title={i18n.qualifCriterias} />
            <Elm src={ElmMain.Elm.ContextualComment} flags={flags} ports={this.setupPorts} />
        </div>

        return flags ? component : <div></div>
    }
}

export default connect(({company}) => ({company}))(ContextualComment)


// WEBPACK FOOTER //
// ./lib/contextualcomment/ContextualComment.js